module.exports = __webpack_public_path__ + "img/menu_img0.73dc0637.png";